import { ataService } from '@/services/ata/ata-service';
import { projectKeys } from '@/utils/queryKeys';
import { useQuery } from '@tanstack/vue-query';
import { computed, toValue, type MaybeRefOrGetter } from 'vue';

export const useAtaDetailsQuery = (
  projectId: MaybeRefOrGetter<string>,
  ataId: MaybeRefOrGetter<string>,
) => {
  return useQuery({
    queryKey: computed(() =>
      projectKeys.ataDetail({
        projectId: toValue(projectId),
        ataId: toValue(ataId),
      }),
    ),
    queryFn: () => ataService.get(toValue(ataId)),
    enabled: computed(() => toValue(ataId) !== '0'),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
};
